import { Badge } from "@/components/ui/badge";
import { useStandardAgentDisplayName } from "@/modules/standardAgent/useStandardAgentDisplayName";

/**
 * Pulsing "‹agent› is working" badge, shown while the agent turn is running so
 * a user can see the record may still change under them. Editing stays
 * available; the badge is a cue, not a lock.
 * @returns The rendered badge.
 */
export function AgentWorkingBadge() {
  const agentName = useStandardAgentDisplayName();
  const label = `${agentName} is working`;

  return (
    <Badge
      variant="outline"
      aria-label={label}
      className="shrink-0 animate-pulse gap-1.5 border-primary/40 text-primary motion-reduce:animate-none"
    >
      <span
        aria-hidden
        className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary"
      />
      {label}
    </Badge>
  );
}
